import { PaginationModule } from 'ngx-bootstrap/pagination';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectModule } from 'primeng/select';
import { TooltipModule } from 'primeng/tooltip';

import { AsyncPipe, CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  AmountCurrencyInputComponent,
  IconComponent,
  SharedModule,
  TranslateLangPipe,
} from '@gs-2.0/shared';

import { PortalCoreModule } from '../../_core/core.module';
import { DonationFormHeaderComponent } from '../../_shared/components/donation-form-header/donation-form-header.component';
import { SelectFieldComponent } from '../../_shared/components/select-field/select-field.component';
import { TextInputComponent } from '../../_shared/components/text-input/text-input.component';
import { FundNameFormatPipe } from '../../_shared/pipes/fund-name-format.pipe';
import { PortalSharedModule } from '../../_shared/shared.module';
import { BankDetailsComponent } from './bank-details/bank-details.component';
import { DonateFormComponent } from './donate-form/donate-form.component';
import { DonateRoutingModule } from './donate-routing.module';
import { FooterSectionComponent } from './footer-section/footer-section.component';
import { ManageRecurringComponent } from './manage-recurring/manage-recurring.component';
import { RecurringService } from './manage-recurring/recurring.service';
import { PostPaymentComponent } from './post-payment/post-payment.component';
import { SummaryComponent } from './summary/summary.component';
import { SwissNextActionComponent } from './swiss-next-action/swiss-next-action.component';
import { WiringInstructionsComponent } from './wiring-instructions/wiring-instructions.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DonateRoutingModule,
    PortalCoreModule,
    PortalSharedModule,
    SharedModule,
    TranslateLangPipe,
    AsyncPipe,
    DatePipe,
    PaginationModule,
    AutoCompleteModule,
    RadioButtonModule,
    SelectModule,
    TooltipModule,
    AmountCurrencyInputComponent,
    InputTextModule,
    CheckboxModule,
    IconComponent,
    TextInputComponent,
    SelectFieldComponent,
    DonationFormHeaderComponent,
  ],

  declarations: [
    DonateFormComponent,
    SummaryComponent,
    PostPaymentComponent,
    SwissNextActionComponent,
    FooterSectionComponent,
    BankDetailsComponent,
    WiringInstructionsComponent,
    ManageRecurringComponent,
  ],

  providers: [RecurringService, FundNameFormatPipe],
})
export class DonateModule {}
